import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=dbb0f0c4&scoped=true"
import script from "./BaseWidget.vue?vue&type=script&lang=ts"
export * from "./BaseWidget.vue?vue&type=script&lang=ts"
import style0 from "./BaseWidget.vue?vue&type=style&index=0&id=dbb0f0c4&prod&lang=scss&scoped=true"
import style1 from "./BaseWidget.vue?vue&type=style&index=1&id=dbb0f0c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb0f0c4",
  null
  
)

export default component.exports